import { render, staticRenderFns } from "./SessionCalendar.vue?vue&type=template&id=0045f5ea&scoped=true"
import script from "./SessionCalendar.vue?vue&type=script&lang=js"
export * from "./SessionCalendar.vue?vue&type=script&lang=js"
import style0 from "./SessionCalendar.vue?vue&type=style&index=0&id=0045f5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045f5ea",
  null
  
)

export default component.exports